import React from 'react';
import ReactDOM from 'react-dom';
import Login from './components/login/Login'
import queryString from "query-string"
/*import './css/index.css';*/

const params = queryString.parse(window.location.search)
ReactDOM.render(<Login clientID={params.cid}/>, document.getElementById('root'));